import { initPageCarousels } from '../functions/carousel.js';

const observed_carousels = new WeakSet();

/**
 * Sincroniza o carrossel quando os resultados ou a visibilidade da busca mudam.
 */
export function initSearchCarousel() {
    const carousel = document.getElementById('search-carousel');
    const results = document.getElementById('search__results-list');
    const already_observed = carousel && observed_carousels.has(carousel);
    let update_frame = null;
    let reset_position = false;

    if (!carousel || !results || already_observed) {
        return;
    }

    observed_carousels.add(carousel);

    function syncCarousel() {
        const slides = results.querySelectorAll('.swiper-slide');
        let swiper = carousel.swiper;
        update_frame = null;

        if (!swiper && slides.length > 0) {
            initPageCarousels('#search-carousel', {
                loop: false,
                watchOverflow: true,
                on: { init: () => scheduleUpdate(false) },
            });
            swiper = carousel.swiper;
        }

        if (!swiper) {
            return;
        }

        swiper.update();

        if (reset_position) {
            swiper.slideTo(0, 0, false);
            reset_position = false;
        }

        if (swiper.pagination) {
            swiper.pagination.render();
            swiper.pagination.update();
        }

        if (swiper.navigation) {
            swiper.navigation.update();
        }

        carousel.classList.toggle('swiper--few-slides', slides.length < swiper.params.slidesPerView);
    }

    function scheduleUpdate(reset) {
        reset_position = reset_position || reset;

        if (update_frame !== null) {
            return;
        }

        update_frame = window.requestAnimationFrame(syncCarousel);
    }

    // Observa apenas os filhos diretos, sem reagir às classes alteradas pelo Swiper.
    const results_observer = new MutationObserver(() => scheduleUpdate(true));
    results_observer.observe(results, { childList: true });

    // Recalcula as medidas ao abrir o painel, inclusive quando estava oculto.
    const resize_observer = new ResizeObserver(() => scheduleUpdate(false));
    resize_observer.observe(carousel);

    scheduleUpdate(true);
}
